<template>
  <div class=""></div>
</template>

<script>
export default {
  data: () => ({
    s: "",
  }),
  // mounted () {
  //   if (localStorage.getItem('onFirstTime')) {

  //   }
  // }
};
</script>

<style>
</style>